export default __webpack_public_path__ + "static/media/loader.3a64c47e.svg";